import { Trans } from "@mbarzda/solid-i18next"
import { type Component } from "solid-js"
import Dialog from "./Dialog/Dialog"
import DialogActions from "./Dialog/DialogActions"
import { t } from "i18next"

const CheckoutUnavailableDialog: Component = () => {
  return (
    <Dialog maxWidth={"434px"}>
      <div class="flex gap-4 mx-auto mb-4">
        <div class="text-black flex gap-2 flex-col">
          <span class="font-semibold">
            <Trans key="ls_generic_error" />
          </span>
          <span class="text-sm">
            {t(
              "We couldn't open the checkout. Please check your connection or pause any ad blocker on this page, then try again."
            )}
          </span>
        </div>
      </div>

      <DialogActions>
        <button
          onClick={() => {
            window.location.reload()
          }}
          class="btn btn--primary h-auto!"
        >
          <Trans key="ls_generic_try_again" />
        </button>
      </DialogActions>
    </Dialog>
  )
}

export default CheckoutUnavailableDialog
